import { createApiClient, type ApiCallParams } from "../api-utils";
import { HttpMethod } from "@/types/https";
import { getWorkchestraOrigin } from "@/lib/utils";

const workchestra = createApiClient({
  baseURL: `${getWorkchestraOrigin()}/api`,
});

export const apiWorkchestraCall = <T>(
  params: Omit<ApiCallParams, "method"> & { method: string }
): Promise<T> => {
  return workchestra.call<T>({
    ...params,
    method: params.method as HttpMethod,
  });
};

export { HttpMethod };
